import React from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import BaseGameTotal from '../base-game-total';

class GameTotal extends BaseGameTotal {
    render() {
        const gameTotal = this.getImpliedGameTotal();
        return (
            <div className="total-text" style={{...this.getBackgroundColor(gameTotal)}}>
                <span>Game Total: {NumberHelper.float(gameTotal, 3)}</span>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {teams},
    } = state;
    return {
        sportConfig,
        teams: teams.all(),
    };
}

const GameTotalComponent = connect(mapStatesToProps)(GameTotal);

export {GameTotalComponent};
